import React from 'react';
import styles from './start-root-box-section.module.scss';
import { CommentsSort } from '../comments-sort/comments-sort';
const classes = styles;
export const StartRootBoxSectionSort = ({ selectedSort, hideSort }) => hideSort ? null : React.createElement(CommentsSort, { className: classes.sort, selectedSort: selectedSort });
//# sourceMappingURL=start-root-box-section-sort.js.map